import Header from './Header'
import Sidebar from './Sidebar'
import PageContent from './PageContent'

export default function MainLayout() {
  return (
    <div className="flex flex-col h-screen bg-white dark:bg-slate-900 overflow-hidden">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto scrollbar-custom dark:bg-slate-900" style={{ backgroundColor: '#00000017' }}>
          <PageContent />
        </main>
      </div>
    </div>
  )
}
